class CartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (event) => {
      event.preventDefault();
      if (event.currentTarget.classList.contains('bundle-product')) return;
      this.closest('cart-items').updateQuantity(this.dataset.index, 0);
    });
    this.product = {
      id: this.dataset.id,
      title: this.dataset.title,
      price: this.dataset.price,
      vendor: this.dataset.vendor,
      category: this.dataset.category,
      variant: this.dataset.variant,
      variantId: this.dataset.variantId,
      quantity: this.dataset.quantity ? parseInt(this.dataset.quantity) : 1
    };
    this.isTrusted = false;

    this.addEventListener('click', function() {
      this.bindRemoveEvents();
    }.bind(this));

    this.addEventListener('click', this.clickIsTrusted.bind(this));
  }

  clickIsTrusted(event) {
    if (event.isTrusted) {
      this.isTrusted = true;
    }
  } 

  bindRemoveEvents() {
    if (typeof removeFromCartGtm === 'function') {
      removeFromCartGtm(this.product, this.product.quantity);
    }
    if (typeof removeFromCartGA4 === 'function') {
      removeFromCartGA4(this.product, this.product.quantity);
    }
    if (typeof removeFromCartPH === 'function') {
      removeFromCartPH(this.product, this.product.quantity);
    }
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class TotalPricesBlock extends HTMLElement {
  constructor() {
    super();
    //this.loadCheckoutPrices();
  }

  async loadCheckoutPrices() {
    const totalPrices = await getCheckoutPrices();
    console.log('totalPrices', totalPrices);
    this.changePrices(totalPrices);
  }

  changePrices(prices) {
    // TODO: Camabiar el data-purchase de Klarna para que el precio se muestre de manera correcta.
    if (!prices) return;
    let totalPriceElement = document.querySelector('.totals__subtotal-value .original__price');
    if (totalPriceElement) {
      totalPriceElement.innerHTML = Shopify.formatMoney(prices.totalPrice);
    }

    if (prices.totalDiscountedPrice) {
      totalPriceElement.classList.add('discounted');
      let totalDiscountedPriceElement = document.querySelector('.totals__subtotal-value .final__price__discounted');
      if (totalPriceElement) {
        totalPriceElement.innerHTML = Shopify.formatMoney(prices.totalDiscountedPrice);
      }
      if (totalDiscountedPriceElement) {
        totalDiscountedPriceElement.innerHTML = Shopify.formatMoney(prices.totalPrice);
      }
    }
  }
}

customElements.define('total-prices-block', TotalPricesBlock);

class DiscountsBlock extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (event) => {
      if (!event.target.classList.contains('add-coupon')) return;
      let fieldInput = this.querySelector('#coupon_code');
      if (!fieldInput) return;
      this.applyCoupon(fieldInput);
    });
  }

  applyCoupon(inputElement) {
    console.log('inputElement', inputElement);
    let coupon_code = inputElement.value;
    fetch(`${routes.base_url}/discount/${coupon_code}?redirect=/checkout`)
    .then(function (response) {
      // The API call was successful!
      if (response.ok) {
        return response.text();
      } else {
        return Promise.reject(response);
      }
    })
    .then(function (html) {
      let parser = new DOMParser();
      let doc = parser.parseFromString(html, 'text/html');

      console.log('CHECKOUT doc', doc);

      if (doc) {
        let discountApplied = false;
        let totalDiscountedPrice = null;
        
        let totalPriceSpan = doc.querySelector('.total-line--subtotal .total-line__price span[data-checkout-subtotal-price-target]');
        let totalPrice = totalPriceSpan.dataset ? totalPriceSpan.dataset.checkoutSubtotalPriceTarget : null;
        
        let discountSpan = doc.querySelector('.total-line--reduction .total-line__price span[data-checkout-discount-amount-target]');
        let discountPrice = discountSpan.dataset ? discountSpan.dataset.checkoutDiscountAmountTarget : null;
        
        if (discountPrice) {
          discountApplied = true;
        }

        if (discountApplied) {
          let totalWithDiscountAppliedSpan = doc.querySelector('.total-line .total-line__price.payment-due span[data-checkout-payment-due-target]');
          totalDiscountedPrice = totalWithDiscountAppliedSpan.dataset ? totalWithDiscountAppliedSpan.dataset.checkoutPaymentDueTarget : null;
        }

        console.log('totalPrice', totalPrice);
        console.log('discountPrice', discountPrice);
        console.log('totalDiscountedPrice', totalDiscountedPrice);

        let totalPrices = {
          totalPrice: totalPrice,
          discountPrice: discountPrice,
          totalDiscountedPrice: totalDiscountedPrice
        };

        let totalPricesBlock = new TotalPricesBlock();
        totalPricesBlock.changePrices(totalPrices);
      }
    })
    .catch(function (err) {
      // There was an error
      console.warn('COUPON CODE error', err);
    });
  }
}

customElements.define('discounts-block', DiscountsBlock);

class PreorderMessage extends HTMLElement {
  constructor() {
    super();
    this.watchPreorder();
  }

  async watchPreorder() {
    let message = null;
    let date = null;
    let target = this.querySelector('.cart__messages-item.preorder-msg')?.querySelector('.cart__preorder-msg-text');
    if (target) {
        if(target.innerHTML !== message) {
            message = target.innerHTML;
            date = target.dataset.preorderdate;
            let cart = await setCartAttributes({
                preorder: message,
                preorder_date: date
            });
            console.log('cart.attributes', cart.attributes);
        }
    }
    else {
      message = '-';
      date = '-';
      let cart = await setCartAttributes({
          preorder: message,
          preorder_date: date
      });
      console.log('cart.attributes', cart.attributes);
    }
  }
}
customElements.define('preorder-message', PreorderMessage);

class CartItems extends HTMLElement {
  constructor() {
    super();

    this.lineItemStatusElement = document.getElementById('shopping-cart-line-item-status');

    this.currentItemCount = Array.from(this.querySelectorAll('[name="updates[]"]'))
      .reduce((total, quantityInput) => total + parseInt(quantityInput.value), 0);

    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);

    this.addEventListener('change', this.debouncedOnChange.bind(this));
  }

  onChange(event) {
    let quantity = parseInt(event.target.value);
    let lineIndex = parseInt(event.target.dataset.index);
    if (quantity === 0) {
      let lineItem =  document.getElementById(`CartItem-${lineIndex}`);
      let lineItemProduct = {
        id: lineItem.dataset.id,
        title: lineItem.dataset.productTitle,
        price: lineItem.dataset.productPrice,
        compareAtPrice: lineItem.dataset.productCompare,
        vendor: lineItem.dataset.productVendor,
        type: lineItem.dataset.productType,
        category: lineItem.dataset.productCategory,
        variant: lineItem.dataset.productVariant,
        sku: lineItem.dataset.productSku,
        quantity: lineItem.dataset.productQuantity ? parseInt(lineItem.dataset.productQuantity) : 1
      };
      if (typeof removeFromCartGA4 === 'function') {
        removeFromCartGA4(lineItemProduct, lineItemProduct.quantity);
      }
      if (typeof removeFromCartPH === 'function') {
        removeFromCartPH(lineItemProduct, lineItemProduct.quantity);
      }
    }
    this.updateQuantity(lineIndex, quantity, document.activeElement.getAttribute('name'));
  }

  getSectionsToRender() {
    if (window.location.pathname != '/cart') {
      return [
        {
          id: "drawer-cart",
          section: window.renderCartSection,
          selector: "#drawer-cart"
        },
        {
          id: "cart-icon-bubble",
          section: "cart-icon-bubble",
          selector: ".shopify-section",
        }
      ];
    } else {
      return [
        {
          id: "cart-icon-bubble",
          section: "cart-icon-bubble",
          selector: ".shopify-section"
        }, {
          id: "cart-content",
          section: document.getElementById("main-cart-items").dataset.id,
          selector: "#cart-content"
        }, {
          id: "main-cart-footer",
          section: document.getElementById("main-cart-footer").dataset.id,
          selector: ".js-contents",
        }
      ];
    }
  }

  updateQuantity(line, quantity, name) {
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });

    fetch(`${routes.cart_change_url}`, {...fetchConfig(), ...{ body }})
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);

        this.getSectionsToRender().forEach((section => {
          const elementToReplace =  document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
          if (section.id == 'cart-content' && window.location.pathname == '/cart') {
            elementToReplace.outerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector, true);
          } else {
            elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
          }
        }));

        this.updateLiveRegions(line, parsedState.item_count);
        this.updateStylesCardLookFromCart(line);
        this.updateScalapayWidgetStyles();

        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) lineItem.querySelector(`[name="${name}"]`).focus();
        this.disableLoading();
      }).catch(() => {
        this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
        document.getElementById('cart-errors').textContent = window.cartStrings.error;
        this.disableLoading();
      });

    if (typeof oneSignalCartUpdate === 'function') {
      oneSignalCartUpdate();
    }
  }

  updateLiveRegions(line, itemCount) {
    if (this.currentItemCount === itemCount) {
      document.getElementById(`Line-item-error-${line}`)
        .querySelector('.cart-item__error-text')
        .innerHTML = window.cartStrings.quantityError.replace(
          '[quantity]',
          document.getElementById(`Quantity-${line}`).value
        );
    }

    this.currentItemCount = itemCount;
    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus = document.getElementById('cart-live-region-text');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector, getOutterContent = false) {
    if (getOutterContent) {
      return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector)
      .outerHTML;
    }
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector)
      .innerHTML;
  }

  enableLoading(line) {
    document.getElementById('main-cart-items').classList.add('cart__items--disabled');
    this.querySelectorAll(`#CartItem-${line} .loading-overlay`).forEach((overlay) => overlay.classList.remove('hidden'));
    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading() {
    document.getElementById('main-cart-items').classList.remove('cart__items--disabled');
  }

  updateStylesCardLookFromCart(line) {
    const cartRemoveButton = this.querySelector(`.cart-item__footer > [data-index="${line}"]`)
    if (cartRemoveButton.isTrusted === true) {

      const productId = cartRemoveButton.getAttribute("data-id");
      const variantId = cartRemoveButton.getAttribute("data-variant_id");
  
      const customEventCardLook = new CustomEvent("customeventcardlook", {
        bubbles: true,
        composed: true,
        detail: {
          product: productId,
          variant: variantId
        }
      });
  
      document.dispatchEvent(customEventCardLook);
    }

  }

  updateScalapayWidgetStyles() {
    const cartSnippets = document.querySelectorAll('[cart-scalapay-snippet]');
    if (cartSnippets.length) {
      cartSnippets.forEach(snippet => {
        const interval = setInterval(() => {
            const firstShadow = snippet.shadowRoot;
            if (firstShadow) {
                const payInstallments = firstShadow.querySelector('scalapay-pay-installments');
                if (payInstallments) {
                    clearInterval(interval)
                    const payInstallmentsShadow = payInstallments.shadowRoot;
                    const payInstallmentsElm = payInstallmentsShadow.firstElementChild;
                    payInstallmentsElm.style.fontSize = '1.3rem';
                    payInstallmentsElm.style.color = '#000';
                }
            }
        }, 100);
      });
    }
  }

}

customElements.define('cart-items', CartItems);